const CATALOG_IMPORT_TYPES = new Set([
  'CATALOG_IMPORT_ACTIVE',
  'CATALOG_IMPORT_COMPLETED',
  'CATALOG_IMPORT_FAILED',
  'CATALOG_IMPORT_CANCELLED',
]);

export function isCatalogImportInboxType(type: string): boolean {
  return CATALOG_IMPORT_TYPES.has(type);
}
